<script>
import Page from "~/pages/_lang/news";
export default Page;
</script>
